import { track } from "../track";

export const trackCreatePhotoUploadTry = () =>
  track({ event: "create_photo_upload_try" });
